var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { create } from "zustand";
var useCollectiveModalityStore = create(function (set, get) { return ({
    setEducationalInstitutionData: function (educationalInstitutionData) {
        return set({ educationalInstitutionData: educationalInstitutionData });
    },
    setAddressData: function (addressData) { return set({ addressData: addressData }); },
    setModality: function (modality) { return set({ modality: modality }); },
    setTechnicalCommitteeTechnicalData: function (technicalCommitteeTechnicalData) {
        return set({ technicalCommitteeTechnicalData: technicalCommitteeTechnicalData });
    },
    pushTechnicalCommitteeTechnicalData: function (payload) {
        var _a;
        var technicalCommitteeTechnicalData = get().technicalCommitteeTechnicalData;
        var existingTechs = technicalCommitteeTechnicalData.comissao_tecnica || [];
        var newTechs = ((_a = payload.comissao_tecnica) === null || _a === void 0 ? void 0 : _a.filter(function (techToAdd) {
            var hasRequiredFields = techToAdd.nome &&
                techToAdd.nome.trim() !== "" &&
                techToAdd.cpf &&
                techToAdd.cpf.trim() !== "" &&
                techToAdd.rg &&
                techToAdd.rg.trim() !== "" &&
                techToAdd.cref &&
                techToAdd.cref.trim() !== "";
            var doesNotExist = !existingTechs.some(function (existingTech) {
                return existingTech.cpf === techToAdd.cpf && existingTech.cpf;
            });
            return hasRequiredFields && doesNotExist;
        })) || [];
        set({
            technicalCommitteeTechnicalData: {
                comissao_tecnica: __spreadArray(__spreadArray([], existingTechs, true), newTechs, true),
            },
        });
    },
    setAthleteDataForm: function (athleteDataForm) { return set({ athleteDataForm: athleteDataForm }); },
    setTermsAndConditionsData: function (termsAndConditionsData) {
        return set({ termsAndConditionsData: termsAndConditionsData });
    },
    technicalCommitteeTechnicalData: { comissao_tecnica: [] },
    reset: function () {
        return set({
            educationalInstitutionData: undefined,
            addressData: undefined,
            modality: undefined,
            termsAndConditionsData: undefined,
            categoryAndModalityData: undefined,
            technicalCommitteeTechnicalData: undefined,
            athleteDataForm: undefined,
        });
    },
}); });
export default useCollectiveModalityStore;
